// components/StatusCard.tsx

// interface StatusCardProps {
//   title: string;
//   count: number;
//   color: "blue" | "red" | "yellow" | "green";
// }

const StatusCard = ({ title, count, color = "bg-blue-500" }) => {
  //   const colors = {
  //     blue: "bg-blue-500 text-white",
  //     red: "bg-red-500 text-white",
  //     yellow: "bg-yellow-400 text-white",
  //     green: "bg-green-500 text-white",
  //   };

  return (
    <div className={`rounded-lg p-4 w-48 shadow-md ${color} text-white`}>
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className="text-2xl font-bold">{count} รายการ</p>
    </div>
  );
};

export default StatusCard;
